import styled from '@emotion/styled';

import { ResponsiveImage } from './responsive_image';

export const RoundedResponsiveImage = styled(ResponsiveImage)`
  border-radius: 8px;
`;
